import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const SwitchGrid = styled(Grid)`
  justify-content: center;
  align-items: center;
`;

export const TableWrapper = styled('div')`
  overflow: auto;
  width: 100%;
  height: 40vh;
  max-height: calc(100vh - 278px);

.gray-out-row {
    background-color: ${COLORS.InputBackground};
    color: #999;
  }
`;